/** Case study listing categories (filter tabs on /case-studies). */

export const DEFAULT_CASE_STUDY_CATEGORIES = [
  { key: 'ai-automation', name: 'AI Automation', iconUrl: '' },
  { key: 'ai-chatbot', name: 'AI Chatbot', iconUrl: '' },
  { key: 'machine-learning', name: 'Machine Learning', iconUrl: '' },
  { key: 'speech-recognition', name: 'Speech Recognition', iconUrl: '' },
  { key: 'edtech', name: 'EdTech', iconUrl: '' },
  { key: 'data-engineering', name: 'Data Engineering', iconUrl: '' },
  { key: 'ai-product-design', name: 'AI Product Design', iconUrl: '' },
  { key: 'healthtech', name: 'HealthTech', iconUrl: '' },
];

export function normalizeCaseStudyCategories(categories) {
  if (!Array.isArray(categories) || !categories.length) {
    return DEFAULT_CASE_STUDY_CATEGORIES.map((c) => ({ ...c }));
  }
  return categories
    .filter((c) => c && c.key && c.name)
    .map((c) => ({
      key: String(c.key).trim(),
      name: String(c.name).trim(),
      iconUrl: c.iconUrl || '',
    }));
}

export function countCardsInCategory(cards, categoryKey, categoryName) {
  return (cards || []).filter(
    (c) =>
      c.categoryKey === categoryKey ||
      c.filterKey === categoryName ||
      c.category === categoryName
  ).length;
}

export function cardMatchesCategoryFilter(card, filterLabel, categories) {
  if (!filterLabel || filterLabel === 'All') return true;
  const cats = normalizeCaseStudyCategories(categories);
  const cat = cats.find((c) => c.name === filterLabel);
  if (!cat) {
    return (card.filterKey ?? card.category) === filterLabel;
  }
  return (
    card.categoryKey === cat.key ||
    card.filterKey === cat.name ||
    card.category === cat.name
  );
}

export function buildCaseStudyListFilters(categories) {
  const cats = normalizeCaseStudyCategories(categories);
  return ['All', ...cats.map((c) => c.name)];
}

export function ensureCardsHaveCategoryKeys(cards, categories) {
  const cats = normalizeCaseStudyCategories(categories);
  const byKey = Object.fromEntries(cats.map((c) => [c.key, c]));
  const byName = Object.fromEntries(cats.map((c) => [c.name, c]));
  const defaultCat = cats[0];

  return (cards || []).map((card) => {
    let cat = card.categoryKey ? byKey[card.categoryKey] : null;
    if (!cat && card.filterKey) cat = byName[card.filterKey];
    if (!cat && card.category) cat = byName[card.category];
    if (!cat) cat = defaultCat;
    const name = cat?.name || card.category || card.filterKey || 'General';
    return {
      ...card,
      categoryKey: cat?.key || card.categoryKey || defaultCat?.key,
      category: name,
      filterKey: name,
      href: card.href || `/case-studies/${card.id}`,
    };
  });
}
